import { EntityTypes } from 'context/entityContext';

/** Renames entityType used in our application to the API specific type */
export const entityTypeToApiType = (
  entityType: EntityTypes | undefined
): string | undefined => {
  switch (entityType) {
    case 'release':
      return 'album';
    default:
      return entityType;
  }
};

/** Renames the API specific type to the entityType used in our application */
export const apiTypeToEntityType = (apiType: string): EntityTypes => {
  switch (apiType) {
    case 'album':
      return 'release';
    default:
      return apiType as EntityTypes;
  }
};
